import { AsyncStoreItem } from '@lib/store';
import { GetSeatmapsResponse } from 'src/sdk-servicing';

/**
 * GetSeatmaps model
 */
export interface GetSeatmapsModel {
  model: GetSeatmapsResponse | null;
}

/**
 * GetSeatmapsResponse model details
 */
export interface GetSeatmapsStateDetails extends AsyncStoreItem {}

/**
 * GetSeatmaps store state
 */
export interface GetSeatmapsState extends GetSeatmapsStateDetails, GetSeatmapsModel {}

/**
 * Name of the GetSeatmaps Store
 */
export const GET_SEATMAPS_STORE_NAME = 'getSeatmaps';

/**
 * GetSeatmaps Store Interface
 */
export interface GetSeatmapsStore {
  /** GetSeatmaps state */
  [GET_SEATMAPS_STORE_NAME]: GetSeatmapsState;
}
